import { ServerTransactionByIdType } from '@expane/data'
import { extractInServiceConsumablesQty, flatTransactionMovements } from '.'

export const filterMovementProductsWithoutInServiceConsumables = (
  transactionById: ServerTransactionByIdType,
) => {
  const inServiceConsumables = extractInServiceConsumablesQty(transactionById)
  const movementProducts = flatTransactionMovements(transactionById)

  for (let i = 0; i < movementProducts.length; i += 1) {
    if (inServiceConsumables[movementProducts[i].productId]) {
      movementProducts[i].quantity -= inServiceConsumables[movementProducts[i].productId]
    }
  }

  return movementProducts.filter(mP => mP.quantity > 0)
}
